import { useParams } from "react-router-dom";

export default function DetalleLider() {
  const { nombre } = useParams();

  return (
    <div>
      <h2>Detalles del líder</h2>
      <p>Estás viendo el perfil de: <strong>{nombre}</strong></p>
    </div>
  );
}
